'use client';

import { cn } from '@core/helpers/misc/GeneralUtils';

export interface OrganizationGlyphProps {
  name: string;
  logoUrl?: string | null;
  className?: string;
}

export function OrganizationGlyph({ name, logoUrl, className }: OrganizationGlyphProps) {
  const initials = getInitials(name);

  if (logoUrl) {
    return (
      <div className={cn('overflow-hidden border border-border bg-card ring-muted-foreground/10', className)}>
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img src={logoUrl} alt={`${name} logo`} className='h-full w-full object-cover' loading='lazy' />
      </div>
    );
  }

  return (
    <div
      className={cn(
        'flex items-center justify-center border border-border bg-muted text-xs font-semibold uppercase tracking-wide text-foreground',
        className
      )}>
      {initials}
    </div>
  );
}

function getInitials(name: string | null | undefined): string {
  if (!name) {
    return '??';
  }
  const parts = name.trim().split(/\s+/);
  if (parts.length === 0) {
    return '??';
  }
  const first = parts[0]?.[0] ?? '';
  const last = parts.length > 1 ? parts[parts.length - 1]?.[0] ?? '' : '';
  const combined = `${first}${last}`.trim().toUpperCase();
  if (combined.length >= 2) {
    return combined.slice(0, 2);
  }
  return (parts[0] ?? '?').slice(0, 2).toUpperCase();
}

